import { airspaceGateway, get, WEBAPP_API_URL } from "api/ky";

export const AIRLINES_URL = `${WEBAPP_API_URL}/api/airlines`;
export const SEARCH_AIRLINES_URL = `${WEBAPP_API_URL}/api/airlines?q=`;

export const fetchAirlines = async (query) => {
  return await get(`${SEARCH_AIRLINES_URL}${query}`, { kyInstance: airspaceGateway });
};

export const fetchAirline = async (airlineIdentifier) => {
  return await get(`${AIRLINES_URL}/${airlineIdentifier}`, { kyInstance: airspaceGateway });
};
